import React from "react";
import {
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Button,
  Container,
} from "reactstrap";

const FilterParameters = ({
  name,
  ain,
  customerCode,
  organizationName,
  requesting,
  handleChange,
  search,
  isVggRole,
}) => {
  return (
    <Container>
      <Row>
        <Col md="3" xs="12">
          <FormGroup>
            <Label>Name</Label>
            <Input
              type="text"
              name="name"
              value={name}
              onChange={(e) => handleChange(e, "name")}
            />
          </FormGroup>
        </Col>
        <Col md="3" xs="12">
          <FormGroup>
            <Label>IN</Label>
            <Input
              type="text"
              name="ain"
              value={ain}
              onChange={(e) => handleChange(e, "ain")}
            />
          </FormGroup>
        </Col>
        <Col md="3" xs="12">
          <FormGroup>
            <Label>Account Code</Label>
            <Input
              type="text"
              name="customerCode"
              value={customerCode}
              onChange={(e) => handleChange(e, "customerCode")}
            />
          </FormGroup>
        </Col>
        {isVggRole && (
          <Col md="3" xs="12">
            <FormGroup>
              <Label>Organization Name</Label>
              <Input
                type="text"
                name="organizationName"
                value={organizationName}
                onChange={(e) => handleChange(e, "organizationName")}
                disabled
              />
            </FormGroup>
          </Col>
        )}
        <Col md="3" xs="12">
          <FormGroup>
            {!isVggRole && (
              <Label className="invisible">Invisible Button Label</Label>
            )}
            <Button
              className={`btn-rounded create-action-btn text-white w-75 ${
                isVggRole ? "mb-3" : ""
              }`}
              onClick={() => search(1, "searchClicked")}
              color={"success"}
              disabled={requesting}
            >
              Search
            </Button>
          </FormGroup>
        </Col>
      </Row>
    </Container>
  );
};

export default FilterParameters;
